<div class="new-element-comp flex-column" appDnd>
  <div
    class="item flex-row space-around"
    [class.active]="isActive('path')"
    (click)="click('path')"
    matTooltip="Line (w)"
    matTooltipPosition="left"
    (mouseenter)="hover('path')"
    (mouseleave)="unhover()"
  >
    <nw-icon
      type="diagonal_line"
      [outlined]="true"
      [size]="18"
      [color]="isActive('path') ? '#072037' : 'white'"
    ></nw-icon>
  </div>
  <div
    class="item flex-row space-around"
    [class.active]="isActive('rectangle')"
    (click)="click('rectangle')"
    matTooltip="Rectangle  (r)"
    matTooltipPosition="left"
    (mouseenter)="hover('rectangle')"
    (mouseleave)="unhover()"
  >
    <nw-icon
      type="check_box_outline_blank"
      [outlined]="true"
      [size]="20"
      [color]="isActive('rectangle') ? '#072037' : 'white'"
    ></nw-icon>
  </div>
  <div
    class="item flex-row space-around"
    [class.active]="isActive('circle')"
    (click)="click('circle')"
    matTooltip="Ellipse (e)"
    matTooltipPosition="left"
    (mouseenter)="hover('circle')"
    (mouseleave)="unhover()"
  >
    <nw-icon
      type="radio_button_unchecked"
      [outlined]="true"
      [size]="20"
      [color]="isActive('circle') ? '#072037' : 'white'"
    ></nw-icon>
  </div>
  <div
    class="item flex-row space-around"
    [class.active]="isActive('glow')"
    (click)="click('glow')"
    matTooltip="Glow (g)"
    matTooltipPosition="left"
    (mouseenter)="hover('glow')"
    (mouseleave)="unhover()"
  >
    <nw-icon
      type="flare"
      [outlined]="true"
      [size]="20"
      [color]="isActive('glow') ? '#072037' : 'white'"
    ></nw-icon>
  </div>
  <div
    class="item flex-row space-around pointer"
    [class.active]="isActive('text')"
    (click)="click('text')"
    matTooltip="Text (t)"
    matTooltipPosition="left"
    (mouseenter)="hover('text')"
    (mouseleave)="unhover()"
  >
    <div [style.color]="isActive('text') ? '#072037' : 'white'">T</div>
  </div>
  <div
    class="item flex-row space-around"
    matTooltip="Image"
    matTooltipPosition="left"
    (mouseenter)="hover('image')"
    (mouseleave)="unhover()"
  >
    <nw-icon
      type="imagesmode"
      [outlined]="true"
      [size]="20"
      [color]="isActive('image') ? '#072037' : 'white'"
      (click)="fileInput.click()"
    ></nw-icon>
    <input
      type="file"
      #fileInput
      (change)="onFileSelected($event)"
      accept="image/*"
      multiple
      hidden
    />
  </div>
  <div
    class="item flex-row space-around cursor-pointer"
    [class.active]="(isAiActive$ | async) || hovered === 'image-gen'"
    (click)="click('image-gen'); $event.stopPropagation()"
    matTooltip="Generate image"
    matTooltipPosition="left"
    (mouseenter)="hover('image-gen')"
    (mouseleave)="unhover()"
    [style.height.px]="28"
  >
    <img
      *ngIf="!(isAiActive$ | async) && hovered !== 'image-gen'"
      src="../../assets/icons/ai.svg"
    />
    <img
      *ngIf="(isAiActive$ | async) || hovered === 'image-gen'"
      src="../../assets/icons/ai_dark.svg"
    />
  </div>
  <div
    class="item flex-row space-around"
    [class.active]="isActive('comment')"
    (click)="click('comment')"
    matTooltip="Comment (c)"
    matTooltipPosition="left"
    (mouseenter)="hover('comment')"
    (mouseleave)="unhover()"
  >
    <nw-icon
      type="chat"
      [outlined]="true"
      [size]="18"
      [color]="isActive('comment') ? '#072037' : 'white'"
    ></nw-icon>
  </div>
</div>
